import timeMethod from './timeMethod'

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
      .replace(/"/g, '\\"')
      .replace(/&/g, '","')
      .replace(/=/g, '":"')
      .replace(/\+/g, ' ') +
    '"}'
  )
}
export const Subtr = (arg1, arg2) => {
  let r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  n = (r1 >= r2) ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
}
// 精度加法
export const accAdd = (arg1, arg2) => {
  let r1, r2, m;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2));
  return (arg1 * m + arg2 * m) / m;
}
export const accMul = (arg1, arg2) => {
  let m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
  } catch (e) {
  }
  try {
    m += s2.split(".")[1].length;
  } catch (e) {
  }
  return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
}
export const compress = (fileObj, callback) => {
  try {
    const image = new Image()
    image.src = URL.createObjectURL(fileObj)
    image.onload = function () {
      const that = this
      // 默认按比例压缩
      let w = that.width
      let h = that.height
      const scale = w / h
      w = fileObj.width || w
      h = fileObj.height || (w / scale)
      let quality = 0.7 // 默认图片质量为0.7
      // 生成canvas
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      // 创建属性节点
      const anw = document.createAttribute('width')
      anw.nodeValue = w
      const anh = document.createAttribute('height')
      anh.nodeValue = h
      canvas.setAttributeNode(anw)
      canvas.setAttributeNode(anh)
      ctx.drawImage(that, 0, 0, w, h)
      // 图像质量
      if (fileObj.quality && fileObj.quality <= 1 && fileObj.quality > 0) {
        quality = fileObj.quality
      }
      // quality值越小，所绘制出的图像越模糊
      const data = canvas.toDataURL('image/jpeg', quality)
      // 压缩完成执行回调
      const newFile = convertBase64UrlToBlob(data, fileObj.name)
      callback(newFile)
    }
  } catch (e) {
    console.log('压缩失败!')
  }
}
function convertBase64UrlToBlob(urlData, filename) {
  const bytes = window.atob(urlData.split(',')[1]) // 去掉url的头，并转换为byte
  // 处理异常,将ascii码小于0的转换为大于0
  const ab = new ArrayBuffer(bytes.length)
  const ia = new Uint8Array(ab)
  for (let i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i)
  }
  return new File([ab], filename, { type: 'image/png' })
}
export const guid = () => {
  function generateSegment(length) {
    let segment = '';
    for (let i = 0; i < length; i++) {
      // 生成0-15之间的随机数并转换为十六进制
      segment += Math.floor(Math.random() * 16).toString(16);
    }
    return segment;
  }
  // 生成完整的GUID
  return `${generateSegment(8)}-${generateSegment(4)}-${generateSegment(4)}-${generateSegment(4)}-${generateSegment(12)}`;
};

//判断当前时间是否已过期 还未开始 在范围内  1 还未开始 2进行中 3已过期
export const getTimeStatus = (time1, time2) => {
  let dateBegin = new Date(time1.replace(/\-/g, "/")); //将-转化为/，使用new Date
  let dateEnd = new Date(time2.replace(/\-/g, "/")); //将-转化为/，使用new Date
  let dateNow = new Date(); //获取当前时间
  let beginDiff = dateNow.getTime() - dateBegin.getTime(); //时间差的毫秒数
  let beginDayDiff = Math.floor(beginDiff / (24 * 3600 * 1000)); //计算出相差天数
  let endDiff = dateEnd.getTime() - dateNow.getTime(); //时间差的毫秒数
  let endDayDiff = Math.floor(endDiff / (24 * 3600 * 1000)); //计算出相差天数
  if (endDayDiff < 0) { //已过期
    return 3
  }
  if (beginDayDiff < 0) { //还没到时间
    return 1
  }
  return 2
}

export const formatDate = (date) => {
  // 处理包含 T 或 t 的时间字符串，将其替换为空格以确保正确解析
  if (typeof date === 'string' && (date.includes('T') || date.includes('t'))) {
    date = date.replace(/[Tt]/, ' ');
  }
  date = new Date(date);
  let tStr = date.getFullYear() + "-" + dealLessTen(date.getMonth() + 1) + "-" + dealLessTen(date.getDate());
  return tStr;
}
export const formatDateStr = (date) => {
  date = new Date(date);
  let tStr = date.getFullYear() + "-" + dealLessTen(date.getMonth() + 1) + "-" + dealLessTen(date.getDate()) + ' ' + dealLessTen(date.getHours()) + ":" +
    dealLessTen(date.getMinutes()) + ":" + dealLessTen(date.getSeconds());
  return tStr;
}
export const formatDTime = (date) => {
  date = new Date(date);
  let tStr = dealLessTen(date.getHours()) + ":" + dealLessTen(date.getMinutes());
  return tStr;
}
//处理日期.小于10 前面加 0
export const dealLessTen = (num) => {
  if (num < 10) {
    return '0' + num
  }
  return num;
}

export const getDateAfterNDays = (n) => {
  const today = new Date();
  // 将天数加到当前日期
  today.setDate(today.getDate() + n);
  return today;
}
// 相差的天数
export const getDiffDay = (date_1, date_2) => {
  // 计算两个日期之间的差值
  let totalDays, diffDate
  let myDate_1 = Date.parse(date_1)
  let myDate_2 = date_2
  // 将两个日期都转换为毫秒格式，然后做差
  diffDate = Math.abs(myDate_1 - myDate_2) // 取相差毫秒数的绝对值

  totalDays = Math.floor(diffDate / (1000 * 3600 * 24)) // 向下取整
  // console.log(totalDays)    

  return totalDays    // 相差的天数
}
export const timeFormat = (time) => {

  const Time = timeMethod.getTime(time).split("T");
  //当前消息日期属于周
  const week = timeMethod.getDateToWeek(time);
  //当前日期0时
  const nti = timeMethod.setTimeZero(timeMethod.getNowTime());
  //消息日期当天0时
  const mnti = timeMethod.setTimeZero(timeMethod.getTime(time));
  //计算日期差值
  const diffDate = timeMethod.calculateTime(nti, mnti);
  //本周一日期0时 （后面+1是去除当天时间）
  const fwnti = timeMethod.setTimeZero(timeMethod.countDateStr(-timeMethod.getDateToWeek(timeMethod.getNowTime()).weekID + 1));
  //计算周日期差值
  const diffWeek = timeMethod.calculateTime(mnti, fwnti);

  if (diffDate === 0) { 				//消息发送日期减去当天日期如果等于0则是当天时间
    return Time[1].slice(0, 5);
  } else if (diffDate < 172800000) { //当前日期减去消息发送日期小于2天（172800000ms）则是昨天-  一天最大差值前天凌晨00:00:00到今天晚上23:59:59
    // return "昨天" + Time[1].slice(0, 5);
    return "昨天";
  } else if (diffWeek >= 0) { 		//消息日期减去本周一日期大于0则是本周
    return week.weekName;
  } else { 							//其他时间则是日期
    return Time[0].slice(5, 10).replace(/\-/g, "/");
  }

}

// 间隔时间差
export const spaceTime = (old, now) => {
  old = new Date(old);
  now = new Date(now);
  var told = old.getTime();
  var tnow = now.getTime();
  if (told > (tnow + 1000 * 60 * 5)) {
    return now;
  } else {
    return '';
  }
}

// 获取本周的开始时间和结束时间
export const getWeekDates = () => {
  // 获取当前日期
  const today = new Date()
  // 计算今天是一周的第几天
  const dayOfWeek = today.getDay(); // 星期天是0，星期一是1
  // 往前推一天到周日开始（如果是周一，则不需要）
  let weekStart = new Date(today);
  if (dayOfWeek !== 0) {
    weekStart.setDate(weekStart.getDate() - dayOfWeek + 1);
  } else {
    weekStart.setDate(weekStart.getDate() - dayOfWeek - 6);
  }
  // 往后推一天到周日结束
  let weekEnd = new Date(today);
  if (dayOfWeek !== 0) {
    weekEnd.setDate(weekEnd.getDate() + (7 - dayOfWeek));
  } else {
    weekEnd.setDate(weekEnd.getDate());
  }
  const start = `${weekStart.getFullYear()}-${(weekStart.getMonth() + 1) > 9 ? weekStart.getMonth() + 1 : '0' + (weekStart.getMonth() + 1)}-${weekStart.getDate() > 9 ? weekStart.getDate() : '0' + weekStart.getDate()}`
  const end = `${weekEnd.getFullYear()}-${(weekEnd.getMonth() + 1) > 9 ? weekEnd.getMonth() + 1 : '0' + (weekEnd.getMonth() + 1)}-${weekEnd.getDate() > 9 ? weekEnd.getDate() : '0' + weekEnd.getDate()}`
  return [start, end]
}
// 获取本月的开始时间和结束时间
export const getMonthDates = () => {
  var now = new Date(); // 获取当前日期时间
  var monthStart = new Date(now.getFullYear(), now.getMonth(), 1); // 获取本月第一天的日期时间
  var monthEnd = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59); // 获取本月最后一天的日期时间（时间为23:59:59）
  let start = formatDate(monthStart)
  let end = formatDate(monthEnd)
  return [start, end]
}
//获取两个时间区间内的所有时间
export function getDayAll(starDay, endDay) {
  var arr = [];
  var dates = [];
  // 设置两个日期UTC时间
  var db = new Date(starDay.replace(/\-/g, "/"));
  var de = new Date(endDay.replace(/\-/g, "/"));
  // 获取两个日期GTM时间
  var s = db.getTime() - 24 * 60 * 60 * 1000;
  var d = de.getTime() - 24 * 60 * 60 * 1000;
  // 获取到两个日期之间的每一天的毫秒数
  for (var i = s; i <= d;) {
    i = i + 24 * 60 * 60 * 1000;
    arr.push(parseInt(i))
  }
  // 获取每一天的时间  YY-MM-DD
  for (var j in arr) {
    var time = new Date(arr[j]);
    var year = time.getFullYear(time);
    var mouth = (time.getMonth() + 1) >= 10 ? (time.getMonth() + 1) : ('0' + (time.getMonth() + 1));
    var day = time.getDate() >= 10 ? time.getDate() : ('0' + time.getDate());
    var YYMMDD = year + '-' + mouth + '-' + day;
    dates.push(YYMMDD)
  }
  return dates
}

// 获取 近多少天的日期
export const timeForMat = (count) => {
  // 拼接时间
  let time1 = new Date()
  // time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000))
  let Y1 = time1.getFullYear()
  let M1 = ((time1.getMonth() + 1) > 9 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
  let D1 = (time1.getDate() > 9 ? time1.getDate() : '0' + time1.getDate())
  let timer1 = Y1 + '-' + M1 + '-' + D1 // 当前时间
  let time2 = new Date()
  time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * count))
  let Y2 = time2.getFullYear()
  let M2 = ((time2.getMonth() + 1) > 9 ? (time2.getMonth() + 1) : '0' + (time2.getMonth() + 1))
  let D2 = (time2.getDate() > 9 ? time2.getDate() : '0' + time2.getDate())
  let timer2 = Y2 + '-' + M2 + '-' + D2 // 之前的7天或者30天
  return [timer2, timer1]
}
//获取指定日期后面的第n天
export const getNthDayAfter = (dateStr, n) => {
  // 拼接时间
  const date = new Date(dateStr);
  date.setDate(date.getDate() + n);
  return date.toISOString().split('T')[0];
}
// 计算某个日期是星期几
export const getDayOfWeek = (dateString) => {
  const days = ['日', '一', '二', '三', '四', '五', '六'];
  const date = new Date(dateString);
  return days[date.getDay()];
}

// 判断是不是今天
export const isToday = (date) => {
  let dateStr = new Date(date.replace(/\-/g, "/"))
  const today = new Date();
  return dateStr.getDate() === today.getDate() // 比较日
    && dateStr.getMonth() === today.getMonth() // 比较月
    && dateStr.getFullYear() === today.getFullYear(); // 比较年
}
// 判断是不是昨天
export const isYesterday = (date) => {
  let dateStr = new Date(date.replace(/\-/g, "/"))
  const today = new Date(); // 当前日期
  const yesterday = new Date(today); // 昨天的日期
  yesterday.setDate(yesterday.getDate() - 1); // 将昨天的日期设置为前一天
  return (
    dateStr.getDate() === yesterday.getDate() && // 比较日
    dateStr.getMonth() === yesterday.getMonth() && // 比较月
    dateStr.getFullYear() === yesterday.getFullYear() // 比较年
  );
}
// 判断是不是今年
export const isYearCross = (date) => {
  let dateM = new Date(date.replace(/\-/g, "/"))
  const currentYear = new Date().getFullYear();
  return dateM.getFullYear() === currentYear;
};
// 判断是不是本周
export const isSameWeek = (date) => { // inDate 是一个date对象
  let dateStr = new Date(date.replace(/\-/g, "/"))
  let inDateStr = dateStr.toLocaleDateString();  // 获取如YYYY/MM/DD的日期
  let nowDate = new Date();
  let nowTime = nowDate.getTime();
  let nowDay = nowDate.getDay();
  for (let i = 0; i < 7; i++) {
    if (inDateStr == (new Date(nowTime + (i - nowDay) * 24 * 3600 * 1000)).toLocaleDateString())
      return true;
  }
  return false;
}
// 判断是不是本月
export const isSameMonth = (date) => { // inDate 是一个date对象
  let dateStr = new Date(date.replace(/\-/g, "/"))
  var nowDate = new Date();
  return ((nowDate.getFullYear() == dateStr.getFullYear()) &&
    (nowDate.getMonth() == dateStr.getMonth()));
}

//获取当前时间的月末时间

export const getCurrentMonthEnd = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  // 创建下个月的第0天，即这个月的最后一天
  const lastDayOfMonth = new Date(year, month + 1, 0);
  // 将时间设置为当天的23:59:59.999
  lastDayOfMonth.setHours(23, 59, 59, 999);
  return lastDayOfMonth;
}

//获取当前时间 前n个月的 月初时间
export const get6MonthStart = (num) => {
  const now = new Date(); // 当前日期
  const sixMonthsAgo = new Date(now.setMonth(now.getMonth() - num)); // 6个月前的日期
  sixMonthsAgo.setDate(1); // 设置为月初的第一天
  return sixMonthsAgo;
}

export const generateCode = () => {
  // 1. 前缀
  const prefix = 'MS';

  // 2. 获取当前时间并格式化为 YYYYMMDDHHmmss
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 补零
  const day = String(now.getDate()).padStart(2, '0');
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  const timestamp = `${year}${month}${day}${hours}${minutes}${seconds}`;

  // 3. 生成 4 位随机数字
  const random = Math.floor(Math.random() * 10000).toString().padStart(4, '0');

  // 4. 拼接编码
  let uniqueCode = `${prefix}${timestamp}${random}`;
  return uniqueCode
}

// 过滤掉空值
export const filterEmpty = (query) => {
  const filteredQuery = Object.fromEntries(
    Object.entries(query).filter(([_, value]) => {
      // 处理数组
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      // 处理对象
      if (value && typeof value === 'object') {
        return Object.keys(value).length > 0;
      }
      // 处理基本类型
      return value !== undefined && 
             value !== null && 
             value !== '' &&
             value !== false;
    })
  );
  return filteredQuery;
}

